import React, { Component } from 'react'
import MasterDataApi from '../../../apis/master-data'
import SchoolApi from '../../../apis/school'
import './class-filter.scss'

class ClassFilter extends Component {
  state = {
    classes: [],
    selectedClass: "All"
  }
  constructor (props) {
    super(props)
    this.getClassDetails()
  }

  getClassDetails () {
    let payload = { limit: 100 }

    SchoolApi.getClassAndBoard(payload)
      .then(school => {
        let classes = []
        for (let i = 0; i < school.classes.length; i++) {
          classes.push({
            title: school.classes[i].name,
            value: school.classes[i].name
          })
        }

        this.setState({ classes: classes })
      })
      .catch(err => {})

  }

  onSelectClass = data => {
    this.props.onSelectClass(data)
  }
  render () {
    const { selectedClass } = this.props
    const {classes} = this.state
    return (
      <div className='pre-assessment cw-plain-card cw-plain-card-wrapper-top mb-4'>
        <div className='row px-4'>
          <div
            onClick={_ => this.onSelectClass()}
            className={`class-title cursor-pointer py-2 mr-4 ${selectedClass ===
              'All' && 'class-active'}`}
          >
            All
          </div>
          {classes?.map(c => (
            <div
              onClick={_ => this.onSelectClass(c.title)}
              className={`class-title cursor-pointer py-2 mr-4 ${selectedClass ===
                c.title && 'class-active'}`}
            >
              {c.title}
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default ClassFilter
